import { useContext } from 'react';
import { AlertContext } from '../utils/AlertContext';

export function useAlert() {
    const context = useContext(AlertContext);
    
    if (!context) {
        throw new Error('useAlert muss innerhalb eines AlertProvider verwendet werden');
    }
    
    const { showAlert, closeAlert, alert } = context;
    
    return { showAlert, closeAlert, alert };
}
